import axios from 'axios'
import { axiosError } from '../../clientUtils.js'
import { getLytAccountingApiBase } from '../../baseUrls'

const BASE_URL = getLytAccountingApiBase()

export function buildConnectUrl(storeId: string, invoiceNumber: string): string {
  if (!storeId || !invoiceNumber) throw new Error('storeId and invoiceNumber are required')
  const qs = new URLSearchParams({ storeId, invoiceNumber }).toString()
  return `${BASE_URL}/api/v1/qbo/connect?${qs}`
}

export interface QboConnection {
  connected: boolean
  company?: {
    companyName?: string
    baseCurrency?: string
    email?: string
  }
}

export async function getConnection(realmId: string): Promise<QboConnection> {
  if (!realmId) throw new Error('realmId is required')
  const url = `${BASE_URL}/api/v1/qbo/connection?realmId=${encodeURIComponent(realmId)}`
  try {
    const res = await axios.get<QboConnection>(url)
    return res.data
  } catch (err) {
    throw axiosError(err)
  }
}

export async function disconnect(realmId: string): Promise<void> {
  if (!realmId) throw new Error('realmId is required')
  const url = `${BASE_URL}/api/v1/qbo/disconnect?realmId=${encodeURIComponent(realmId)}`
  try {
    await axios.post(url)
  } catch (err) {
    throw axiosError(err)
  }
}